<template>
    <div>
        <div class="button-group">
            注意：状态为开启，可以在相应位置展示 “选择模板” 功能；关闭后，相应位置隐藏 “选择模板” 功能。
        </div>
        <div style="clear:both"></div>
        <a-table
            :columns="columns"
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            rowKey="id"
        >
        <span slot="list_order" slot-scope="text, record">
            <a-input v-model="record.list_order" class="inputs" id="list_order" size="small"
                     oninput="value=value.replace(/[^\d]/g,'')"/>
        </span>
            <span slot="status" slot-scope="text, record">
            <a-switch
                @click="onChange(record)"
                :checked="text == 1 ? true : false"
            />
        </span>
        </a-table>
        <a-button type="primary" class="top_btn" @click="goHistory">返回</a-button>
    </div>
</template>
<script>
import API from "./api";
import {changStatus} from "@/utils/utils";

export default {
    data() {
        return {
            pagination: {
                pageNo: 1,
                pageSize: 0, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
            },
            search: {
                name: "",
            },
            columns,
            data: [],
            loading: true,
            sortLists: [],
            editId: null
        };
    },
    created() {
        this.$store.state.adminleftnavnum = "/ACustomTemplate/ACustomTemplateList"; //设置左侧导航2-2 active
    },
    methods: {
        //获取列表数据
        getList(page) {
            API.ACustomTemplateCate.GET_LIST({page: page}).then((res) => {
                this.data = res.data.data.data
                this.pagination.total = res.data.data.total
                this.pagination.pageSize = res.data.data.per_page
                this.pagination.current = res.data.data.current_page
                this.loading = false
            });
        },
        //改变状态
        onChange(row) {
            let Json = {id: row.id, status: row.status == 0 ? 1 : 0};
            changStatus(API.ACustomTemplateCate.CHANG_STATUS, [Json]).then(res => {
                if (res == true) {
                    this.getList()
                }
            })
        },
        goHistory() {
            this.$router.push({path: "/CustomTemplate/CustomTemplateList"});
        }
    },
    mounted() {
        this.getList();
    },
}
const columns = [
    {
        title: '分类名称',
        dataIndex: 'name',
        width: "20%",
        ellipsis: true,
    },
    {
        title: '状态',
        dataIndex: 'status',
        width: "20%",
        scopedSlots: {customRender: "status"},
        ellipsis: true,
    },
];
</script>
<style scoped>
.button-group {
    float: left;
}
#list_order {
    width: 50px;
}
</style>
